







































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as util from "@/util";

@Component
export default class Password extends Vue {
  @Prop({ default: false }) showConfirm!: boolean;
  @Prop({ default: "password" }) name!: string;
  @Prop({ default: "Contraseña" }) label!: string;
  @Prop({ default: null }) checkWeakness!: boolean;
  @Prop({ default: "off" }) autocomplete!: string;
  @Prop({ default: 8 }) minLength!: number;
  @Prop({ default: 100 }) maxLength!: number;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "" }) value!: string;
  @Prop({ default: true }) vertical!: boolean;

  password = "";
  passwordShown = false;
  confirmPassword = "";

  @Watch("value")
  changeValue(newValue: string) {
    this.password = newValue;
  }

  @Watch("password")
  onPasswordChange() {
    this.checkIfTriggerEvent();
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get isHorizontal(): boolean {
    return !this.vertical && this.showConfirm;
  }

  checkIfTriggerEvent() {
    this.$emit("input", this.password);
  }

  get passwordRules() {
    const rules = [util.rules.required(this.lang.rulePasswordReq)];
    if (this.checkWeakness) {
      // Extra weakness rules
      rules.push(util.rules.lowerCase(this.lang.passLowercase));
      rules.push(util.rules.upperCase(this.lang.passUppercase));
      rules.push(util.rules.hasNumber(this.lang.passNumber));
      rules.push(util.rules.hasNonAlphanumeric(this.lang.passEspecialChar));
      rules.push(
        util.rules.length(`${this.lang.ruleMinChar1}${this.minLength}${this.lang.ruleMinChar2}`, this.minLength)
      );
    }
    return rules;
  }

  get confirmPasswordRules() {
    return [util.rules.required(this.lang.ruleConfirmPasword), this.equalConfirm];
  }

  equalConfirm(val: string) {
    return (!!val && this.password === val) || this.lang.ruleConfirmation + this.label;
  }
}
